import { differenceInMinutes } from 'date-fns';

export const calculateDuration = (startDate: Date, endDate: Date): string => {
    const diff = differenceInMinutes(endDate, startDate) + 1;

    if (diff < 60) return `${diff}m`;

    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;

    if (hours === 0) return `${minutes}m`;
    if (minutes === 0) return `${hours}u`;
    return `${hours}u ${minutes}m`;
};
